<template>
  <div id="addcompany">
    <v-app>
    <v-container fluid grid-list-lg>
      <v-flex justify-center xs12 sm12 md12>

    <form>
      <v-text-field
      v-model="company"
      :error-messages="errors.collect('company')"
      label="Company"
      required
      ></v-text-field>

      <v-btn color="blue lighten-1" type="submit" @click="saveInput" to="/">submit</v-btn>
      <v-btn to="/">Cancel</v-btn>
    </form>
      </v-flex>
  </v-container>
  </v-app>
 </div>
</template>

<script>
import db from './firebaseinit'
export default {
  name: 'addcompany',
  data () {
    return {
      companies: [],
      company: null
    }
  },
  created () {
    db.collection("companies")
      .orderBy("company")
      .get()
      .then(querySnapshot => {
        querySnapshot.forEach(doc => {
          const data = {
            'company': doc.data().company
          };
          this.companies.push(data);
        });
      });
  },
  methods: {
    saveInput () {
      db.collection('companies').add({
        company: this.company
      })
      .then(docRef => this.$router.push('/'))
        .catch(error => console.log(err))
        alert('Company created');
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/AddCompany.vue